import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { Children, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CommericialLeasingOppurtunitesPageContent } from "./CommericialLeasingOppurtunitesPageContent";
import { CommericialLeasingOppurtunitesPageHeading } from "./CommericialLeasingOppurtunitesPageHeading";

export const CommericialLeasingOppurtunitesList = () => {
  const query = useQuery();
  const navigate = useNavigate();
   useEffect(() => {
      if(query.get('id')){
        return;
      }
      if (query.get("activeTab") === "commercialLeasingOpportunitiesList") {
        navigate(
          `/dedicated/corporate/business-oppurtunities?activeTab=commercialLeasingOpportunitiesList&subActiveTab=${
            query.get('subActiveTab') || "retailOutletList"}`,
          {
            replace: true,
          }
        );
      } 
    }, [query.get("activeTab"), query.get('subActiveTab')]);

  const aboutEramanChildItems = [
    {
      label: "Retail Outlet List",
      key: 'retailOutletList',
      children: <CommericialLeasingOppurtunitesPageContent/>
    },
    {
      label: "Food & Beverage List",
      key: 'foodAndBeverageList',
      children: <CommericialLeasingOppurtunitesPageContent/>
    },
    {
      label: "Service Outlet List",
      key: 'serviceOutletList',
      children: <CommericialLeasingOppurtunitesPageContent/>
    },
    {
      label: "Others List",
      key: 'othersList',
      children: <CommericialLeasingOppurtunitesPageContent/>
    },
  ];

  return (
      <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={aboutEramanChildItems}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
  );
};
